<template>
    <div>
        <div class="oquefazemos">
            <Container>
                <div class="oquefazemos__container">
                    <div class="oquefazemos__image">
                        <img src="@/assets/images/pencil.jpg"
                            alt="Lápis">
                    </div>
                    <div class="oquefazemos__title">
                        <h1>O que fazemos?</h1>
                    </div>
                    <div class="oquefazemos__list">
                        <ul>
                            <li v-for="(work, index) in works"
                                :key="index">
                                <div class="icon">
                                    <img :src="work.icon"
                                        :alt="work.name"
                                        :title="work.name">
                                </div>
                                {{ work.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </Container>
        </div>
    </div>
</template>

<script>
import Container from '@/components/Container'
export default {
    name: 'oquefazemos',
    components: {
        Container,
    },
    data: () => ({
        works: [
            {
                icon: require('@/assets/icons/digital-art-draw.svg'),
                name: 'Branding'
            },
            {
              icon: require('@/assets/icons/blue-triangle.svg'),
                name: 'Design Gráfico',
            },
            {
                icon: require('@/assets/icons/shell.svg'),
                name: 'Sites',
            },
            {
                icon: require('@/assets/icons/yellow-gem-horizontal.svg'),
                name: 'Marketing Digital',
            },
            {
                icon: require('@/assets/icons/tetris-piece.svg'),
                name: 'Vídeos',
            },
            {
                icon: require('@/assets/icons/digital-art-retangle.svg'),
                name: 'Apresentações',
            },
            {
                icon: require('@/assets/icons/yellow-gem.svg'),
                name: 'Ambientação',
            },
            {
                icon: require('@/assets/icons/blue-gem.svg'),
                name: 'Campanha 360º',
            }
        ],
    }),
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.oquefazemos {
    background: #f5f5f5;
    height: 102.4rem;
    overflow: hidden;
    position: relative;
    @media(max-width: $max-sm) {
        height: 42rem;
    }

    &__container {
        display: grid;
        gap: 5rem;
        padding-top: 12rem;
        grid-template-areas: "image title" "image list";
        @media(max-width: $max-sm) {
            gap: 3.4rem;
            grid-template-areas: "title title" "image list";
            padding-top: 0;
        }
    }
    &__image {
        grid-area: image;
        position: relative;
        width: 14.3rem;
        @media(max-width: $max-sm) {
            width: 8.4rem;
        }
        img {
            position: absolute;
            right: 0;
            top: 0;
            width: 27.2rem;
            height: auto;
            @media(max-width: $max-sm) {
                position: relative;
                width: 100%;
            }
        }
    }
    &__title {
        grid-area: title;
        height: 14.8rem;
        display: flex;
        align-items: flex-end;
        @media(max-width: $max-sm) {
            height: 7.5rem;
        }
        h1 {
            font-size: 7rem;
            font-weight: 900;
            color: #14191C;
            @media(max-width: $max-sm) {
                font-size: 3rem;
            }
        }
    }
    &__list {
        grid-area: list;
        ul {
            display: grid;
            gap: 4rem 9.5rem;
            width: 70rem;
            grid-template-columns: 1fr 1fr;
            @media(max-width: $max-sm) {
                grid-template-columns: 1fr;
                gap: 1.1rem;
                margin-top: 1.2rem;
            }
        }
        li {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 2.5rem;
            font-weight: 900;
            color: #14191C;
            @media(max-width: $max-sm) {
                font-size: 1.5rem;
            }
        }
    }
    .icon {
        width: 6.5rem;
        height: 5.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 3rem;
        @media(max-width: $max-sm) {
            display: none;
        }
        img {
            min-width: 35px;
            max-width: 100%;
        }
    }
}
</style>
